import React from "react";
import { cx } from "utils/join-classnames";
import styles from "./StatusBullit.module.scss";

interface Props {
    status: "online" | "offline";
    className: string;
}

const StatusBullit: React.FC<Props> = ({ status, className }: Props) => {
    const [bullitStatus, setBullitStatus] = React.useState<
        "offline" | "online" | null
    >(null);

    React.useEffect(() => {
        const statusTimeout = setTimeout(
            () => {
                setBullitStatus(status);
            },
            Math.round(1000 + Math.random() * 1000),
        );
        return () => {
            clearTimeout(statusTimeout);
        };
    }, [status]);
    return (
        <div
            className={cx(
                styles.bullit,
                bullitStatus && bullitStatus === "offline"
                    ? styles.bullit__offline
                    : null,
                bullitStatus && bullitStatus === "online"
                    ? styles.bullit__online
                    : null,
                className,
            )}
        />
    );
};

export default StatusBullit;
